export const IMAGES = [
  {
    src: "https://wallpaperaccess.com/full/19693.jpg",
  },
  {
    src: "https://p4.wallpaperbetter.com/wallpaper/997/794/382/miles-morales-spiderman-miles-morales-spider-man-peter-parker-spider-gwen-hd-wallpaper-preview.jpg",
  },
  {
    src: "https://images.hdqwalls.com/wallpapers/spiderman-miles-morales-2020-4k-h0.jpg",
  },
  {
    id: 4,
    src: "https://i.pinimg.com/originals/62/cf/26/62cf260b79e3304823105ee0c4732a0c.jpg",
  },
  {
    id: 5,
    src: "https://p4.wallpaperbetter.com/wallpaper/792/35/779/spider-man-dark-background-black-cgi-wallpaper-preview.jpg",
  },
  {
    id: 6,
    src: "https://www.solofondos.com/wp-content/uploads/2021/12/Spiderman-4k-Wallpaper-scaled.jpg",
  },
  {
    id: 7,
    src: "https://www.pixel4k.com/wp-content/uploads/2019/09/all-verse-spiderman_1568055003.jpg",
  },
  {
    id: 8,
    src: "https://images.hdqwalls.com/wallpapers/2020-black-spiderman-4k-artwork-ul.jpg",
  },
  {
    id: 9,
    src: "https://c4.wallpaperflare.com/wallpaper/435/861/252/sony-playstation-playstation-5-4k-spider-man-hd-wallpaper-preview.jpg",
  },
  {
    id: 10,
    src: "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e1dff05c-7db2-4c17-9e85-9ae503d8432e/de2w360-2ca328ad-0e58-4388-88fa-b3f89e03c0f8.jpg/v1/fill/w_1280,h_720,q_75,strp/spiderman_game_4k_wallpaper_by_bilalnuman_de2w360-fullview.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzIwIiwicGF0aCI6IlwvZlwvZTFkZmYwNWMtN2RiMi00YzE3LTllODUtOWFlNTAzZDg0MzJlXC9kZTJ3MzYwLTJjYTMyOGFkLTBlNTgtNDM4OC04OGZhLWIzZjg5ZTAzYzBmOC5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.N0H7RjM8VZv3C6T6Nj6iaGTIMGARWEP1HkQUH0QbBbw",
  },
  {
    id: 11,
    src: "https://www.teahub.io/photos/full/97-975297_spiderman-wallpaper-4k.jpg",
  },
];
